import { getApplicationExtraInfo } from '@axo/shared/data-access/api/loan_application/extra_info';
import { useAPI } from '@axo/shared/data-access/provider';
import { useQuery } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useApplicationExtraInformation(
  applicationID: string | undefined,
) {
  const api = useAPI();
  const queryKey = applicationKeys.extraInfo(applicationID);

  return useQuery({
    queryKey,
    queryFn: () => getApplicationExtraInfo(api)(applicationID ?? ''),
    enabled: api.token.length > 0 && Boolean(applicationID),
  });
}
